type UserInfo = {
  id: number
}

const checkUserInfo = (cookieName = 'userInfo'): UserInfo | undefined => {
  // Return if called on server
  if (typeof document === 'undefined') {
    return
  }

  const userInfoCookie = document.cookie.split('; ').find(row => row.startsWith(cookieName))

  if (userInfoCookie) {
    return JSON.parse(decodeURIComponent(userInfoCookie.split('=')[1]))
  }

  return
}

export default checkUserInfo
